import { RainbowBorderButton } from "./RainbowBorderButton";
import { jsx as _jsx } from "react/jsx-runtime";
export function ViewTransactionButton(_ref) {
  let {
    onClick,
    disabled
  } = _ref;
  return /*#__PURE__*/_jsx(RainbowBorderButton, {
    dataTestId: "view-transaction-button",
    disabled: disabled,
    onClick: onClick,
    children: "View attestation"
  });
}